const ALLOWED_TAB_TYPES = {
  editorial: 'editorial',
  lineup: 'lineup',
  ranking: 'ranking',
  result: 'result',
  schedule: 'schedule',
  sportstable: 'sportstable',
  statistics: 'statistics',
  startingLineup: 'startingLineup',
  startingList: 'startingList',
  worldCup: 'worldCup',
  entityOverview: 'entityOverview',
  entitySportstable: 'entitySportstable',
  entityCompetitors: 'entityCompetitors',
} as const

export { ALLOWED_TAB_TYPES }
